import React from 'react';
import { FaInstagram } from 'react-icons/fa';

const HeaderSocials = () => {
  return (
    <div className='header_socials'>
      <a href='https://www.instagram.com/mbarto11/' target='_blank' rel='noopener noreferrer'>
        <FaInstagram />
      </a>
    </div>
  );
};

export default HeaderSocials;
  